/**
 * @generated SignedSource<<d9e9bc600cd8de4cc8e25da6800cde91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type publicFactSheetPage_Query$variables = {
  slug: string;
};
export type publicFactSheetPage_Query$data = {
  readonly publicFactSheet: {
    readonly memberSince: string | null | undefined;
    readonly metrics: ReadonlyArray<{
      readonly benchmark: number | null | undefined;
      readonly benchmarkLabel: string | null | undefined;
      readonly key: string;
      readonly label: string;
      readonly unit: string;
      readonly value: number | null | undefined;
    }>;
    readonly onWaitlist: boolean;
    readonly referralCode: string | null | undefined;
  } | null | undefined;
};
export type publicFactSheetPage_Query = {
  response: publicFactSheetPage_Query$data;
  variables: publicFactSheetPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onWaitlist",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberSince",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referralCode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "benchmark",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "benchmarkLabel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "publicFactSheetPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PublicFactSheet",
        "kind": "LinkedField",
        "name": "publicFactSheet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FactSheetMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "publicFactSheetPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PublicFactSheet",
        "kind": "LinkedField",
        "name": "publicFactSheet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FactSheetMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e9919f80574f56ab10f40c469ec233b2",
    "id": null,
    "metadata": {},
    "name": "publicFactSheetPage_Query",
    "operationKind": "query",
    "text": "query publicFactSheetPage_Query(\n  $slug: String!\n) {\n  publicFactSheet(slug: $slug) {\n    onWaitlist\n    memberSince\n    referralCode\n    metrics {\n      key\n      label\n      value\n      unit\n      benchmark\n      benchmarkLabel\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "30277f9477b741338dc4f379d3492bba";

export default node;
